// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__28cvf","actions":"GroupTable_actions__3Nx6_","deleteModalFooter":"GroupTable_deleteModalFooter__3WiUg"};